module.exports = __webpack_public_path__ + "static/media/gray.4482e9f0.png";